import { Alert } from '@mui/material'
import React from 'react'
import useLocales from 'src/hooks/useLocales'
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

// Extend Day.js with plugins
dayjs.extend(utc);
dayjs.extend(timezone);

function Notification({ message, cancelDate,severity }) {
      const userTZ = dayjs.tz.guess(); 

    const today = dayjs().tz(userTZ).startOf("day");


    if(!cancelDate?.isAfter(today)) return <></>

    return (
        <>
            <Alert severity={severity} variant='filled' sx={{ borderRadius: 0, px: 2 }}>{message}</Alert>
        </>
    )
}

export default Notification